module.exports = fox._r("images/logo_cp_2x.png", __webpack_public_path__ + "_/_/_/common/frame/images/logo_cp_2x.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logo_cp_2x.png
// module id = 118
// module chunks = 2